import React from 'react';

/**
 * Breadcrumb navigation bar for C4 drill-down.
 * Renders only when depth > 1 (i.e. we've drilled into a sub-context).
 */
const C4Breadcrumb = ({ contextStack, onJumpTo, onGoBack }) => {
  if (!contextStack || contextStack.length <= 1) return null;

  const current = contextStack[contextStack.length - 1];

  return (
    <div
      style={{
        position: 'absolute',
        top: 64,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 200,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        background: 'rgba(255,255,255,0.96)',
        border: '1px solid #e0e0e0',
        borderRadius: 8,
        padding: '4px 10px 4px 6px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
        fontSize: 13,
        color: '#333',
        userSelect: 'none',
        pointerEvents: 'auto',
      }}
    >
      {/* Back button */}
      <button
        onClick={onGoBack}
        title="Go back"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '2px 8px 2px 4px',
          fontSize: 15,
          color: '#555',
          lineHeight: 1,
          borderRight: '1px solid #eee',
          marginRight: 6,
        }}
      >
        ←
      </button>

      {/* Path items */}
      {contextStack.map((ctx, i) => (
        <React.Fragment key={ctx.id}>
          {i > 0 && (
            <span style={{ color: '#bbb', margin: '0 3px', fontSize: 12 }}>›</span>
          )}
          <button
            onClick={() => i < contextStack.length - 1 && onJumpTo(ctx.id)}
            disabled={i === contextStack.length - 1}
            style={{
              background: 'none',
              border: 'none',
              cursor: i === contextStack.length - 1 ? 'default' : 'pointer',
              padding: '2px 4px',
              fontSize: 13,
              color: i === contextStack.length - 1 ? '#111' : '#007ACC',
              fontWeight: i === contextStack.length - 1 ? 600 : 400,
              textDecoration: i === contextStack.length - 1 ? 'none' : 'underline',
            }}
          >
            {ctx.label}
          </button>
        </React.Fragment>
      ))}

      {/* Current view label badge */}
      {current.viewLabel && (
        <span
          style={{
            marginLeft: 8,
            fontSize: 11,
            color: '#666',
            background: '#f0f4f8',
            borderRadius: 4,
            padding: '1px 7px',
            border: '1px solid #dde3ea',
            whiteSpace: 'nowrap',
          }}
        >
          {current.viewLabel}
        </span>
      )}
    </div>
  );
};

export default C4Breadcrumb;
